import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ReferenceBox from '../../common/reference-box';
import './my-article-box.css';

class MyArticleBox extends Component {
  
  render() {
    const imgSrc = `/images/articles/${this.props._id}/summary.png`;
    const articleLink = `/articles/${this.props.linkId}`;

    return (
      <div className='my-article-box little-grow-animation'>
        <ReferenceBox imgSrc={imgSrc} link={articleLink} {...this.props} />
      </div>
    );
  }
}

MyArticleBox.propTypes = {
  _id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  tags: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  linkId: PropTypes.string.isRequired,
  readMinutes: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  level: PropTypes.number,  
  buffText: PropTypes.string
};

export default MyArticleBox;